import Promise from 'bluebird'
import axios from 'axios'
import utils from '@/utils'
import moment from 'moment'
import store from '@/store'

const state = {
  apiAutomations: []
}

const getters = {
  getApiAutomation(state) {
    return state.apiAutomations
  }
}

const mutations = {
  setApiAutomation(state, apiAutomation) {
    state.apiAutomations = apiAutomation
  }
}

const actions = {
  fetchApiAutomations({ commit }) {
    return new Promise(resolve => {
      axios.get('/api/v1/apiAutomations').then(response => {
        let apiAutomations = [...response.data._embedded.apiAutomations]
        apiAutomations = apiAutomations.map(apiAutomation =>
          utils.processResp(apiAutomation)
        )
        commit('setApiAutomation', apiAutomations)
        resolve(apiAutomations)
      })
    })
  },

  fetchApiAutomation({ commit, state }, hexId) {
    return new Promise(resolve => {
      axios
        .get('/api/v1/apiAutomations/' + hexId)
        .then(response => {
          let apiAutomation = utils.processResp(response.data)
          resolve(apiAutomation)
        })
        .catch(response => {
          store.dispatch('directNotification', {
            type: 'error',
            message: 'Unble to fetch Response',
            description: response.toString(),
            timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
          })
        })
    })
  },

  saveApiAutomation({ commit, state }, apiAutomationData) {
    let saveBody = {
      apiAutomationName: apiAutomationData.apiAutomationName,
      apiAutomationDescription: apiAutomationData.apiAutomationDescription,
      apiAutomationJson: apiAutomationData.apiAutomationJson
    }
    if (apiAutomationData.hexId) {
      return axios
        .patch(`/api/v1/apiAutomations/${apiAutomationData.hexId}`, saveBody)
        .then(response => {
          let apiAutomation = utils.processResp(response.data)
          store.dispatch('directNotification', {
            type: 'success',
            message: 'API has been saved Successfully',
            description:
              'API ' + apiAutomation.hexId + ' has been successfully saved',
            timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
          })
        })
    } else {
      return axios.post('/api/v1/apiAutomations', saveBody).then(response => {
        let apiAutomation = utils.processResp(response.data)
        store.dispatch('directNotification', {
          type: 'success',
          message: 'API has been saved Successfully',
          description:
            'API ' + apiAutomation.hexId + ' has been successfully saved',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      })
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
